export default "dist/images/block-accordion-colored.3f93495.png";